<template>
<div>
  <div class="wistia_embed wistia_async_as4et377jz">
    &nbsp;
  </div>

  <div
    id="caring_for_gods_people_choose"
    class="tbk-vid-embed"
  >
    <a
      id="melissa_pohlman"
      class="embedded_video"
      href="#wistia_u28ic3ec1e?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="mark_aune"
      class="embedded_video"
      href="#wistia_uoi7gnz715?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="irma_banales"
      class="embedded_video"
      href="#wistia_vnt9x7ndtq?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('as4', 15, this.showSelect)

    this.tbk.loadCrossTime('u28', 203, this.showSelect)
    this.tbk.loadCrossTime('uoi', 172, this.showSelect)
    this.tbk.loadCrossTime('vnt', 95, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        u28: this.tbk.autoPlay,
        uoi: this.tbk.autoPlay,
        vnt: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#caring_for_gods_people_choose
  display: none
  a
    text-decoration: none
#melissa_pohlman
  position: absolute
  top: 0
  left: 0
  width: calc(100% / 3)
  height: 100%
#mark_aune
  position: absolute
  top: 0
  left: calc(100% / 3)
  width: calc(100% / 3)
  height: 100%
#irma_banales
  position: absolute
  top: 0
  left: calc(200% / 3)
  width: calc(100% / 3)
  height: 100%

</style>

